import { ReactNode } from "react";

interface FeatureSectionProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  gradient?: boolean;
}

export function FeatureSection({
  title,
  subtitle,
  children,
  className = "",
  gradient = false
}: FeatureSectionProps) {
  return (
    <section className={`py-24 sm:py-32 ${gradient ? "bg-gradient-to-br from-muted/30 via-muted/10 to-background" : ""} ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {(title || subtitle) && (
          <div className="text-center mb-16">
            {title && (
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
